import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import RestaurantPage from './pages/RestaurantPage';
import MenuPage from './pages/MenuPage';
import BarPage from './pages/BarPage';
import SnookerPage from './pages/SnookerPage';
import PoolPage from './pages/PoolPage';
import ContactPage from './pages/ContactPage';
import ReservationPage from './pages/ReservationPage';
import CoachingPage from './pages/CoachingPage';
import BreakfastOfferPage from './pages/BreakfastOfferPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import BigBreakfastPage from './pages/BigBreakfastPage';
import RestaurantOfferPage from './pages/RestaurantOfferPage';
import EmailConfirmedPage from './pages/EmailConfirmedPage';
import NewsPage from './pages/NewsPage';
import NewsArticlePage from './pages/NewsArticlePage';

const SiteLayout: React.FC = () => {
  const { pathname } = useLocation();
  const isCampaign = /^\/(?:BB10|CSB10)(?:\/|$)/i.test(pathname);

  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen bg-primary-black">
        {!isCampaign && <Navigation />}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/restaurant" element={<RestaurantPage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/bar" element={<BarPage />} />
          <Route path="/snooker" element={<SnookerPage />} />
          <Route path="/pool" element={<PoolPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/book" element={<ReservationPage />} />
          <Route path="/coaching" element={<CoachingPage />} />
          <Route path="/breakfast-offer" element={<BreakfastOfferPage />} />
          <Route path="/BB10" element={<BigBreakfastPage />} />
          <Route path="/BB10/thank-you" element={<BigBreakfastPage thankYou />} />
          <Route path="/BB10/confirmed" element={<EmailConfirmedPage source="BB10" />} />
          <Route path="/CSB10" element={<RestaurantOfferPage />} />
          <Route path="/CSB10/thank-you" element={<RestaurantOfferPage thankYou />} />
          <Route path="/CSB10/confirmed" element={<EmailConfirmedPage source="CSB10" />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/news/page/:page" element={<NewsPage />} />
          <Route path="/news/:slug" element={<NewsArticlePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
        {!isCampaign && <Footer />}
      </div>
    </>
  );
};

const App: React.FC = () => <Router><SiteLayout /></Router>;

export default App;
